jQuery(document).ready(function () {
    jQuery("#progress span:eq(0)").addClass("active");

    jQuery("#ys_cartInfo #ys_cart .ys_basket tbody tr").each(function () {
        jQuery("td.ys_last", this).append(jQuery("td.ys_first span.ys_itemInfo em", this));
        jQuery("td.ys_last em a", this).html("<img src=https://turbifycdn.com/ty/cdn/knifeart/ka-checkout-remove.png>");
        jQuery("td.ys_last em a", this).css("cssText", "display:inline-block;vertical-align:middle;padding-left:15px;cursor:pointer;");
    });

    jQuery("p#ys_paypalOr img").attr("src", "https://turbifycdn.com/ty/cdn/knifeart/ka-checkout-cart-or.png");
    jQuery(".ys_paypalSection .ys_paypalCartPage:first").addClass('paypalCredit');
    jQuery(".ys_paypalSection .ys_paypalCartPage:last").addClass('paypalReg');
    jQuery(".ys_paypalSection .ys_paypalCartPage.paypalCredit .ysco_img_btn img").attr("src", "https://sep.turbifycdn.com/ty/cdn/knifeart/ka-checkout--paypal-credit.png");
    jQuery(".ys_paypalSection .ys_paypalCartPage.paypalReg .ysco_img_btn img").attr("src", "https://sep.turbifycdn.com/ty/cdn/knifeart/ka-checkout--paypal.png");
    jQuery(".ys_paypalSection .ys_paypalCartPage.paypalReg").after(jQuery(".ys_paypalSection .ys_paypalCartPage.paypalCredit"));

    if (cart.items && typeof (cart.items.find(element => element.name.toLowerCase().match("chris reeve"))) != 'undefined') {
        $("#ys_shipBillOtherInfo").hide();
    }

    if (pdIsMobileDevice()) {
        jQuery("td.ys_quantity input.text").prop("type", "tel");
    }
    parent.postMessage(JSON.stringify(cart), "*");

    if (waitingRoomItems.some(item => ids.includes(item))) {
        vrScript = document.createElement('script');
        vrScript.src = 'https://site.knifeart.com/waitingRoom/ssl/ytimes-waitingroom.js';
        document.body.appendChild(vrScript);
    }


    const anchors = document.querySelectorAll("form[name='CheckoutForm'] a[href^='https://store.turbify.net/knifeart/']");
    anchors.forEach(a => {
        a.href = a.href.replace(/^https:\/\/store\.turbify\.net\/knifeart\//, "https://www.knifeart.com/");
    });

    let cartCnt = 0;
    if (cart.items) {
        cart.items.forEach(item => {
            cartCnt += parseInt(item.qty, 10);
        });
    }

    document.cookie = "cartcnt=" + cartCnt + "; domain=.knifeart.com; path=/; secure; samesite=None";
});

